export default __webpack_public_path__ + "static/media/Logo-Mini.bbacce4a.svg";